var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function mergeCategorySettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        dataZoom: settings === null || settings === void 0 ? void 0 : settings.dataZoom,
        areaDefault: settings === null || settings === void 0 ? void 0 : settings.areaDefault,
        smoothDefault: settings === null || settings === void 0 ? void 0 : settings.smoothDefault,
        showSymbolDefault: settings === null || settings === void 0 ? void 0 : settings.showSymbolDefault,
        synchronizeAxisBounds: settings === null || settings === void 0 ? void 0 : settings.synchronizeAxisBounds,
        barWidth: settings === null || settings === void 0 ? void 0 : settings.barWidth,
        barCategoryGap: settings === null || settings === void 0 ? void 0 : settings.barCategoryGap,
        barGap: settings === null || settings === void 0 ? void 0 : settings.barGap, // 传递barGap配置
    };
}
export function mergeScatterSettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        visualMap: settings === null || settings === void 0 ? void 0 : settings.visualMap,
        showRegressionLine: settings === null || settings === void 0 ? void 0 : settings.showRegressionLine,
    };
}
export function mergeHeatmapSettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        visualMap: settings === null || settings === void 0 ? void 0 : settings.visualMap,
        cellBorderColor: settings === null || settings === void 0 ? void 0 : settings.cellBorderColor,
    };
}
export function mergeGeoHeatmapSettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        visualMap: settings === null || settings === void 0 ? void 0 : settings.visualMap,
        geo: settings === null || settings === void 0 ? void 0 : settings.geo,
    };
}
export function mergeRadarSettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        shape: settings === null || settings === void 0 ? void 0 : settings.shape,
        splitNumber: settings === null || settings === void 0 ? void 0 : settings.splitNumber,
        showSymbol: settings === null || settings === void 0 ? void 0 : settings.showSymbol,
        areaDefault: settings === null || settings === void 0 ? void 0 : settings.areaDefault,
    };
}
export function mergeGaugeSettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        style: settings === null || settings === void 0 ? void 0 : settings.style,
        min: settings === null || settings === void 0 ? void 0 : settings.min,
        max: settings === null || settings === void 0 ? void 0 : settings.max,
        startAngle: settings === null || settings === void 0 ? void 0 : settings.startAngle,
        endAngle: settings === null || settings === void 0 ? void 0 : settings.endAngle,
        splitNumber: settings === null || settings === void 0 ? void 0 : settings.splitNumber,
        showPointer: settings === null || settings === void 0 ? void 0 : settings.showPointer,
        showProgress: settings === null || settings === void 0 ? void 0 : settings.showProgress,
    };
}
var LEGEND_MARGIN = 16; // 图例离外边距
var LEGEND_VERTICAL_CENTER = "center";
function resolveLegendOrientation(position) {
    if (!position) {
        return { orient: "horizontal", top: LEGEND_MARGIN, left: "center" };
    }
    switch (position) {
        case "left":
            return { orient: "vertical", left: LEGEND_MARGIN, top: LEGEND_VERTICAL_CENTER };
        case "right":
            return { orient: "vertical", right: LEGEND_MARGIN, top: LEGEND_VERTICAL_CENTER };
        case "bottom":
            return { orient: "horizontal", bottom: LEGEND_MARGIN, left: "center" };
        default:
            return { orient: "horizontal", top: LEGEND_MARGIN, left: "center" };
    }
}
export function buildLegend(dataLegend, settingLegend) {
    var _a;
    var merged = __assign(__assign({ show: true }, dataLegend), settingLegend);
    if (merged.show === false) {
        return { show: false };
    }
    var orientation = resolveLegendOrientation(merged.position);
    var config = {
        show: true,
        orient: (_a = merged.orient) !== null && _a !== void 0 ? _a : orientation.orient,
        // 图标和间距设置（默认值，可被外部配置覆盖）
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 8,
        // 自动换行（水平图例时）
        width: orientation.orient === "horizontal" ? "auto" : undefined,
        // 鼠标移上去时显示 tooltip（显示完整名称）
        tooltip: {
            show: true,
            formatter: function (params) {
                // params.name 包含原始的系列名称
                return params.name || "";
            },
        },
        // 选中状态下的样式
        selectedMode: true,
    };
    // 处理图例文字显示
    // 优先级：外部 formatter > showText > 默认（不显示文字）
    if (merged.formatter !== undefined) {
        // 如果外部提供了 formatter，使用外部的（支持函数或字符串）
        config.formatter = merged.formatter;
    }
    else if (merged.showText === true) {
        // 如果 showText 为 true，不设置 formatter，使用 ECharts 默认行为（显示文字）
        // 不设置 formatter 即可
    }
    else {
        // 默认 Tag 模式：不显示文字（不占空间），hover 时通过 tooltip 显示
        config.formatter = function () { return ""; };
    }
    Object.assign(config, orientation);
    if (merged.position === "left") {
        config.align = "left";
    }
    else if (merged.position === "right") {
        config.align = "right";
    }
    // 允许外部传入其他 ECharts 图例配置项（如 textStyle、itemGap 等）
    // 这些配置会覆盖默认值
    var externalConfig = __assign(__assign({}, dataLegend), settingLegend);
    var allowedExternalKeys = [
        "textStyle",
        "itemWidth",
        "itemHeight",
        "itemGap",
        "itemStyle",
        "selectedMode",
        "data",
        "width",
        "height",
        "padding",
        "borderRadius",
        "borderColor",
        "borderWidth",
        "backgroundColor",
        "shadowBlur",
        "shadowColor",
        "shadowOffsetX",
        "shadowOffsetY",
    ];
    allowedExternalKeys.forEach(function (key) {
        if (externalConfig[key] !== undefined) {
            config[key] = externalConfig[key];
        }
    });
    return config;
}
/** 统一默认：字体 12、字重 300、不裁切，便于所有图表 tooltip 一致 */
var DEFAULT_TOOLTIP_TEXT_STYLE = { fontSize: 12, fontWeight: 300 };
export function buildTooltip(dataTooltip, settingTooltip) {
    var _a, _b;
    var merged = __assign(__assign({ enable: true, trigger: "axis" }, dataTooltip), settingTooltip);
    if (merged.enable === false) {
        return { show: false };
    }
    var config = {
        show: true,
        trigger: (_a = merged.trigger) !== null && _a !== void 0 ? _a : "axis",
        textStyle: __assign(__assign({}, DEFAULT_TOOLTIP_TEXT_STYLE), merged.textStyle),
        confine: (_b = merged.confine) !== null && _b !== void 0 ? _b : false,
        borderWidth: 0,
    };
    if (merged.formatter) {
        config.formatter = merged.formatter;
    }
    if (merged.position) {
        config.position = merged.position;
    }
    if (merged.axisPointer !== undefined) {
        config.axisPointer = merged.axisPointer;
    }
    return config;
}
export function buildDataZoom(dataZoom, settingZoom) {
    var merged = __assign(__assign({ enable: false, start: 0, end: 100 }, settingZoom), dataZoom);
    if (!merged.enable) {
        return undefined;
    }
    return [
        {
            type: "inside",
            start: merged.start,
            end: merged.end,
        },
        {
            type: "slider",
            start: merged.start,
            end: merged.end,
        },
    ];
}
export function mergePieSettings(settings) {
    return {
        legend: settings === null || settings === void 0 ? void 0 : settings.legend,
        tooltip: settings === null || settings === void 0 ? void 0 : settings.tooltip,
        radius: settings === null || settings === void 0 ? void 0 : settings.radius,
        roseType: settings === null || settings === void 0 ? void 0 : settings.roseType,
        showLabels: settings === null || settings === void 0 ? void 0 : settings.showLabels,
        labelLine: settings === null || settings === void 0 ? void 0 : settings.labelLine,
        explode: settings === null || settings === void 0 ? void 0 : settings.explode,
        cornerRadius: settings === null || settings === void 0 ? void 0 : settings.cornerRadius,
        labelContent: settings === null || settings === void 0 ? void 0 : settings.labelContent,
        sliceGap: settings === null || settings === void 0 ? void 0 : settings.sliceGap,
    };
}
export function buildVisualMap(dataVisualMap, settingVisualMap, fallback) {
    var _a, _b, _c, _d, _e, _f, _g;
    var merged = __assign(__assign({ show: true, calculable: true }, dataVisualMap), settingVisualMap);
    if (merged.show === false) {
        return { show: false };
    }
    var config = {
        show: (_a = merged.show) !== null && _a !== void 0 ? _a : true,
        min: (_c = (_b = merged.min) !== null && _b !== void 0 ? _b : fallback === null || fallback === void 0 ? void 0 : fallback.min) !== null && _c !== void 0 ? _c : 0,
        max: (_e = (_d = merged.max) !== null && _d !== void 0 ? _d : fallback === null || fallback === void 0 ? void 0 : fallback.max) !== null && _e !== void 0 ? _e : 100,
        calculable: (_f = merged.calculable) !== null && _f !== void 0 ? _f : true,
    };
    if ((_g = merged.inRangeColors) === null || _g === void 0 ? void 0 : _g.length) {
        config.inRange = { color: merged.inRangeColors };
    }
    return config;
}
